<template>
  <div class="reel-wrapper">
    <div
      class="fb-reel-frame"
      :style="{
        backgroundImage: `url(${post?.file?.preview})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }"
    >
      <!-- Header -->
      <div
        class="header-top d-flex justify-space-between align-center px-3 pt-2"
      >
        <div class="d-flex align-center">
          <v-icon class="text-white me-2">mdi-arrow-left</v-icon>
          <span class="text-white font-weight-bold">Video</span>
        </div>
        <div class="d-flex align-center">
          <v-icon class="text-white me-3">mdi-magnify</v-icon>
          <v-icon class="text-white me-3">mdi-camera-outline</v-icon>
          <v-avatar size="28">
            <img src="https://i.pravatar.cc/100" />
          </v-avatar>
        </div>
      </div>

      <video
        v-if="
          post?.file?.file &&
          post?.file?.file?.type &&
          post?.file?.file?.type.startsWith('video/')
        "
        width="100%"
        :src="post?.file?.preview"
        autoplay
        muted
        loop
      ></video>
      <!-- Side Stats -->
      <div class="stats-right d-flex flex-column align-center pe-2">
        <v-icon class="text-white mb-2">mdi-thumb-up-outline</v-icon>
        <span class="text-white text-caption mb-4">111k</span>
        <v-icon class="text-white mb-2">mdi-comment-outline</v-icon>
        <span class="text-white text-caption mb-4">2.3k</span>
        <v-icon class="text-white">mdi-share-outline</v-icon>
      </div>

      <!-- Bottom Info -->
      <div class="bottom-info px-3 pb-2">
        <div class="d-flex align-center mb-1">
          <v-avatar size="28" class="me-2">
            <img src="https://i.pravatar.cc/100" />
          </v-avatar>
          <div>
            <div class="d-flex align-center">
              <span class="text-white font-weight-bold">Mark Ramos</span>
              <span class="text-white text-caption ms-1"
                >with Rachel Podrez</span
              >
            </div>
            <div class="text-caption text-white">Public</div>
          </div>
        </div>

        <div class="text-white text-body-2 mb-1">
          Look what we found down here! 😂🧠
          <span class="text-caption">#adventure #nature #diving</span>
        </div>
        <div class="text-caption text-white text-opacity-75 mb-2">
          2871 comments
        </div>

        <div class="d-flex justify-space-between align-center">
          <span class="text-white text-caption">🎵 Audio • Original</span>
          <v-icon class="text-white">mdi-dots-horizontal</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { publishPost } from "@/store/publishPost/publishPost.js";
import HeaderOne from "@/components/publish_post_components/reviews/svgs/facebookReelHeader1.svg";
import HeaderTwo from "@/components/publish_post_components/reviews/svgs/facebookReelHeader2.svg";
import Footer from "@/components/publish_post_components/reviews/svgs/facebookReelFooter.svg";
export default {
  name: "FacebookReelReview",
  components: {},
  data() {
    return {
      HeaderOne,
      HeaderTwo,
      Footer,
      store: publishPost(),
      post: {},
    };
  },
  watch: {
    "store.getCarouselSlider": {
      handler() {
        this.post = this.store.post["facebook"].find(
          (item) => item.type === "reel"
        );
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.reel-wrapper {
  width: 100%;
  max-width: 420px;
  margin: auto;
  aspect-ratio: 9 / 16;
  position: relative;
}

.fb-reel-frame {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 24px;
  overflow: hidden;
  background: black;
}

.header-top {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent);
}

.stats-right {
  position: absolute;
  right: 0;
  top: 45%;
  z-index: 10;
}

.bottom-info {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
}

.video-background ::v-deep(.v-img__img) {
  object-position: center center;
}
</style>
